import { GANTT_BIND_TYPE_LIST } from '@gantt/components/GanttCreateOrEdit'
import { JSX_REGISTRY } from '@gantt/constants'

import { VectorIcon } from '../../../wiskey-react-components/src'

export const serializeIconToJsx = (icon: VectorIcon | null): string => {
  if (!icon) return ''
  const tagName = JSX_REGISTRY[GANTT_BIND_TYPE_LIST.ICON].name
  const parts = [`type="${icon.type}"`, `value="${icon.value}"`, `size={${icon.size}}`]
  if (icon.color) parts.push(`color="${icon.color}"`)

  return `<${tagName} ${parts.join(' ')} />`
}
